import {useMemo} from "react";
import {useSelector} from "react-redux";
import {
    getWorkspaceRole,
    resolveActiveWorkspaceUserRoles,
} from "./workspace-permissions";

export function useWorkspaceRole() {
    const workspaceMembership = useSelector((state) => state.app.workspaceMembershipData);
    const graphMembership = useSelector((state) => state.workspaceGraph.workspaceMembership);
    const graphUserRoles = useSelector((state) => state.workspaceGraph.userRoles);
    const userRoles = useMemo(
        () => resolveActiveWorkspaceUserRoles(
            workspaceMembership,
            graphMembership,
            graphUserRoles,
        ),
        [workspaceMembership, graphMembership, graphUserRoles],
    );
    const workspaceRole = useMemo(() => getWorkspaceRole(userRoles), [userRoles]);

    return {
        workspaceMembership,
        userRoles,
        workspaceRole,
        role: workspaceRole?.role || null,
    };
}
